/* eslint-disable prefer-template */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import Select from 'react-select';
import Loader from 'components/common/Loader';
import { RM_LIST } from 'utils/CommonGraphQL';

const styles = {
  control: (base) => ({
    ...base,
    fontSize: '14px',
    minHeight: '38px',
  }),
  menu: (base) => ({
    ...base,
    fontSize: '13px',
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const PMField = ({ defaultValue, handleChange, id, ...rest }) => {
  const [selectValue, setSelectValue] = useState(defaultValue || '');
  const menuPortalTarget =
    typeof document === 'undefined' ? null : document.body;

  useEffect(() => {
    setSelectValue(defaultValue || '');
  }, [defaultValue]);

  const { data, loading, error } = useQuery(RM_LIST, {
    variables: {
      filter: [
        {
          key: 'name',
          value: 'Purchase_Manager',
          setAttribute: 'roles',
          type: 'STRING',
          op: 'IN',
        },
        {
          key: 'isDeleted',
          value: false,
          type: 'BOOLEAN',
          op: 'EQ',
        },
        {
          key: 'status',
          value: 'ACTIVE',
          type: 'STRING',
          op: 'EQ',
        },
      ],
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  const onSelectChange = (e) => {
    setSelectValue(e);
    if (handleChange) handleChange(e);
  };

  if (loading) return <Loader size="sm" />;
  if (error) return `There is an error on this page : ${error.message} `;
  return (
    <div
      className={`payment-terms-select status_${defaultValue?.id || ''}`}
    >
      <Select
        styles={styles}
        menuPortalTarget={menuPortalTarget}
        menuPosition="fixed"
        classNamePrefix="react-select"
        value={selectValue}
        onChange={onSelectChange}
        options={data?.usersFilter?.users || []}
        keys={{ id: 'id', label: 'firstName' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => {
          const firstName = option?.firstName || '';
          const lastName = option?.lastName || '';
          return `${firstName} ${lastName}`.trim();
        }}
        placeholder="Select PM"
        {...rest}
      />
    </div>
  );
};

export default PMField;
